// extracted by mini-css-extract-plugin
export default {"copy":"Qea-z"};